<template>
  <div>
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Asegurador</th>
          <th scope="col">Fecha Desde</th>
          <th scope="col">Fecha Hasta</th>
          <th scope="col">Descripción</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="seguro in datosPaginados" :key="seguro.idSeguro">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(seguro.idSeguro)" title="Editar">edit_square</i></td>
          <td>{{seguro.aseguradorNombre}}</td>
          <td>{{getFormattedDate(seguro.fechaDes, 'DD/MM/YYYY')}}</td>
          <td>{{getFormattedDate(seguro.fechaHas, 'DD/MM/YYYY')}}</td>
          <td>{{seguro.descripcion}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteSeguro(seguro.idSeguro)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPaginaTodos(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idSeguro" class="form-label">IdSeguro</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idSeguro" name="idSeguro" v-model="datoSeguro.idSeguro" disabled>
                </div>
              </div>
            </div>
<!-- Botón Lista de Valores  Persona -->
<!--
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idPersona" class="form-label"> Persona</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idPersona" name="idPersona" v-model="datoSeguro.idPersona">
                      <option v-for="persona in personas" :value="persona.idPersona" :key="persona.idPersona">
                        {{ persona.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
-->
<!-- Botón Lista de Valores  Persona -->
<!-- Botón Lista de Valores  Asegurador -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idAsegurador" class="form-label"> Asegurador</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idAsegurador" name="idAsegurador" v-model="datoSeguro.idAsegurador">
                      <option v-for="asegurador in aseguradors" :value="asegurador.idAsegurador" :key="asegurador.idAsegurador">
                        {{ asegurador.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Asegurador -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="descripcion" class="form-label">Descripción</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="descripcion" name="descripcion" v-model="datoSeguro.descripcion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaDes" class="form-label">Fecha Desde</label>
                </div>
                <div class="col-4">
                  <input type="date" class="form-control" id="fechaDes" name="fechaDes" v-model="formattedFechaDes" required>
                </div>
                <div class="col-2">
                  <label for="fechaHas" class="form-label">Fecha Hasta</label>
                </div>
                <div class="col-4">
                  <input type="date" class="form-control" id="fechaHas" name="fechaHas" v-model="formattedFechaHas" required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarSeguro" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditSeguro" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
  </div>
</template>
<script>
import { validarForm } from '@/modules/validacionesForms.js'
import dateFormat from '@/modules/dateFormat.js';

import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  props: {
    p_idPersona: {
      type: String,
      required: true
    }
  },
  components : {
  },
  data () {
    return {
      seguros : [],
      datoSeguro : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      personas: [],
      aseguradors: [],
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  computed: {
    formattedFechaDes: {
      get() {
        if (!this.datoSeguro.fechaDes) return '';
        const date = new Date(this.datoSeguro.fechaDes);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      },
      set(value) {
        const date = new Date(value);
        date.setMinutes(date.getMinutes() + date.getTimezoneOffset()); // Ajuste para zona horaria
        this.datoSeguro.fechaDes = date.toISOString();
      }
    },
    formattedFechaHas: {
      get() {
        if (!this.datoSeguro.fechaHas) return '';
        const date = new Date(this.datoSeguro.fechaHas);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      },
      set(value) {
        const date = new Date(value);
        date.setMinutes(date.getMinutes() + date.getTimezoneOffset()); // Ajuste para zona horaria
        this.datoSeguro.fechaHas = date.toISOString();
      }
    }
  },
  mounted () {
    this.getDataPaginaTodos(this.paginaActual)
    this.fetchAseguradors()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas(){
      return Math.ceil(this.seguros.length / this.elementosPorPagina)
    },
/*    
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwseguros/nombre/'+this.nombreBusqueda).then(response=>{
          this.seguros=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.seguros.slice(ini,fin);
        });
      }
    },
*/
    getDataPaginaTodos(noPagina){
      api.get('/vwseguros/idpersona/'+this.p_idPersona).then(response=>{
      this.seguros=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.seguros.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarForm(){
      const requiredFields = [
        'idAsegurador'
        ,'descripcion'
        ,'fechaDes'
      ];
      const requiredFieldsText = [
        'idAsegurador'
        ,'descripcion'
        ,'fechaDes'
      ];
      return validarForm(this.datoSeguro, requiredFields, requiredFieldsText);
    },
    async guardarSeguro(){
      if(this.validarForm() === 1){
        try {
          this.datoSeguro.idPersona = this.p_idPersona;
          await api.post('/seguros', this.datoSeguro)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Seguro creada exitosamente!", "success");
          this.getDataPaginaTodos(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditSeguro(){
      if(this.validarForm() === 1){
        try {
          await api.post('/seguros', this.datoSeguro)
          $('#ventanaModal').modal('hide');
          this.getDataPaginaTodos(this.paginaActual);
          swal("Correcto!", "Seguro creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoSeguro={}
      this.titulo   = 'Crear Seguro'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirModalEditar(idSeguro){
      this.modalWindow = true
      if(idSeguro != null){    
           api.get('/vwseguros/'+idSeguro).then(resp=>{
          this.datoSeguro = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Seguro'
      this.btnCrear = false
      this.btnEditar= true
    },
    async deleteSeguro (idSeguro) {
      try{
        await api.delete('/seguros/'+idSeguro)
          this.getDataPaginaTodos(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
    fetchAseguradors() {
      fetch('http://localhost:8080/api/v1/vwaseguradors')
        .then(response => response.json())
        .then(data => {
          this.aseguradors = data;
        })
        .catch(error => {
          console.error('Error fetching aseguradors:', error);
        });
    },
  },
}
</script>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
